module.exports = __webpack_public_path__ + "static/media/YM54_1.ef9e6e00.jpg";